/* ============================================================
   AŞKIM: product page
   Ties the colour and size buttons to real stock. Choosing a colour
   greys out the sizes that sold in that colour and switches off sizes
   never made in it. Keeps the hidden variant list, the price, the Add to
   bag button, the WhatsApp message, the photographs on show and the address
   bar in step with the choice. Shows the buy bar on phones once the real
   button has scrolled away.
   ============================================================ */
(function () {
  var root = document.querySelector('[data-product-root]');
  var dataEl = document.querySelector('[data-product-variants]');
  if (!root || !dataEl || !window.AskimVariants) return;

  var V = window.AskimVariants;
  var variants = JSON.parse(dataEl.textContent);
  var prices = {};
  try { prices = JSON.parse(document.querySelector('[data-variant-prices]').textContent); } catch (e) {}

  var select = root.querySelector('[data-variant-select]');
  var groups = [].slice.call(root.querySelectorAll('.option-group'));
  var track = root.querySelector('[data-track]');
  var shownColour;
  var waLink = root.querySelector('[data-wa-link]');
  var colourName = root.querySelector('[data-colour-name]');

  var current = variants.filter(function (v) { return String(v.id) === select.value; })[0] || variants[0];
  var selected = current.options.slice();

  function colourIndex() {
    for (var i = 0; i < groups.length; i++) {
      if (groups[i].querySelector('.swatch-btn')) return +groups[i].getAttribute('data-option-index');
    }
    return -1;
  }
  var CI = colourIndex();

  function paint() {
    groups.forEach(function (g) {
      var index = +g.getAttribute('data-option-index');
      var isColour = index === CI;
      var states = isColour ? V.colourStates(variants, index) : V.optionStates(variants, selected, index);
      g.querySelectorAll('button[data-value]').forEach(function (b) {
        var st = states.filter(function (s) { return s.value === b.getAttribute('data-value'); })[0];
        var on = b.getAttribute('data-value') === selected[index];
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        b.classList.toggle('active', on);
        b.classList.toggle('is-sold', !!st && st.exists && !st.available);
        /* A colour button is never switched off: choosing it moves to a
           size that exists. Sizes are switched off when never made in the
           chosen colour. */
        b.disabled = !isColour && (!st || !st.exists);
        var base = b.getAttribute('data-value');
        b.setAttribute('aria-label', base + (st && st.exists && !st.available ? ', sold out' : '') + (st && !st.exists ? ', not made in this colour' : ''));
      });
    });

    select.value = String(current.id);
    document.querySelectorAll('[data-price]').forEach(function (el) {
      if (prices[current.id]) el.textContent = prices[current.id];
    });
    document.querySelectorAll('[data-add-button]').forEach(function (b) {
      b.disabled = !current.available;
      b.textContent = current.available ? 'Add to bag' : 'Sold out';
    });

    if (CI >= 0 && colourName) colourName.textContent = selected[CI];

    if (waLink && /^https:\/\/wa\.me\//.test(waLink.href)) {
      var base = waLink.href.split('?')[0];
      var text = waLink.getAttribute('data-wa-prefix') + (CI >= 0 ? ' in ' + selected[CI] : '') + '.';
      waLink.href = base + '?text=' + encodeURIComponent(text);
    }

    /* Only the chosen colour's photographs, in admin order, from its first.
       Photos of other colours wait, hidden, until their colour is chosen.
       A size change leaves the photos where they are. */
    var colourNow = CI >= 0 ? selected[CI] : null;
    if (track && colourNow !== shownColour) {
      shownColour = colourNow;
      var figs = [].slice.call(track.querySelectorAll('.figure[data-media-id]'));
      var byId = {};
      var media = figs.map(function (f) {
        byId[f.getAttribute('data-media-id')] = f;
        return { id: f.getAttribute('data-media-id'), position: +f.getAttribute('data-position') };
      });
      var show = V.galleryPlan(media, variants, CI, colourNow);
      show.forEach(function (id) {
        byId[id].hidden = false;
        track.appendChild(byId[id]);
      });
      figs.forEach(function (f) {
        if (show.indexOf(f.getAttribute('data-media-id')) < 0) { f.hidden = true; track.appendChild(f); }
      });
      if (window.AskimGallery) window.AskimGallery.refresh();
    }

    if (window.history && history.replaceState) {
      var url = new URL(location.href);
      url.searchParams.set('variant', current.id);
      history.replaceState(null, '', url.toString());
    }
  }

  groups.forEach(function (g) {
    var index = +g.getAttribute('data-option-index');
    g.addEventListener('click', function (e) {
      var b = e.target.closest('button[data-value]');
      if (!b || b.disabled) return;
      current = V.resolveChoice(variants, selected, index, b.getAttribute('data-value')) || current;
      selected = current.options.slice();
      paint();
    });
  });

  /* Someone using the plain list (for instance a screen reader user who
     tabs into it) keeps the buttons in step. */
  select.addEventListener('change', function () {
    current = variants.filter(function (v) { return String(v.id) === select.value; })[0] || current;
    selected = current.options.slice();
    paint();
  });

  paint();

  /* ---- Buy bar on phones ---- */
  var bar = document.querySelector('[data-buy-bar]');
  var anchor = root.querySelector('.pdp__actions');
  if (bar && anchor) {
    var shown = false;
    var cta = bar.querySelector('.buy-bar__cta');
    var upd = function () {
      var past = anchor.getBoundingClientRect().bottom < 0;
      if (past === shown) return;
      shown = past;
      bar.classList.toggle('in', past);
      bar.setAttribute('aria-hidden', past ? 'false' : 'true');
      if (cta) cta.tabIndex = past ? 0 : -1;
    };
    upd();
    window.addEventListener('scroll', upd, { passive: true });
    window.addEventListener('resize', upd, { passive: true });
  }
})();
